// extracted by mini-css-extract-plugin
export default {"container":"styles_container__DXrP9","container__txtSec":"styles_container__txtSec__9-bWJ","container__txt2":"styles_container__txt2__YE8LV","chart":"styles_chart__MQgsi"};